<template>
  <!-- 关联页帮助视频、文档 -->
  <!-- 黑色透明遮罩层 -->
  <div class="mask-layer" v-show="visible">
    <div class="page-helper-container">
      <i class="el-icon-error close-button" @click="handleClose"></i>
      <!-- 视频列表 -->
      <div class="video-list scrollbar-hidden">
        <ul>
          <li v-for="item,index in data" :key="item.id">
            <div class="video-title">{{ item.videoTitle }}</div>
            <div :class="['video-box' ,active == index ?'video-box-active':'']" @click="selectVideo(index)">
              <img class="video-cover" :src="item.videoCover" alt="">
              <i :class="[active==index && playing?'el-icon-video-pause':'el-icon-video-play','play-button-small']"></i>
              <i :class="[active==index && playing?'el-icon-video-pause':'el-icon-video-play','play-button-large']"></i>
              <span class="video-play-duration">{{ item.videoTime }}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="player-box scrollbar-hidden" v-if="data && data.length && data[active]">
        <!-- 视频播放 -->
        <div class="video-player scrollbar-hidden">
          <div class="video-player-title">{{data[active].videoTitle}}</div>
          <div class="video-player-remark">{{ data[active].videoRemark }}</div>
          <video ref="videoPlayer" :src="data[active].videoUrl" style="width: 100%;margin-top: 10px;" controls></video>
        </div>
        <!-- 演示文字 -->
        <div class="text-player scrollbar-hidden">
          <div v-html="data[active].content"></div>
          <!-- <div style="position: absolute;bottom: 10px;right: 10px">
            <el-button type="primary" @click="viewMore(data[active].id)">查看更多</el-button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      active: 0,
      playing: false
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.$refs.videoPlayer.addEventListener('play', this.handlePlay)
        this.$refs.videoPlayer.addEventListener('pause', this.handlePause)
        this.$refs.videoPlayer.play()
      }
      else {
        this.$refs.videoPlayer.removeEventListener('play', this.handlePlay)
        this.$refs.videoPlayer.removeEventListener('pause', this.handlePlay)
      }
    }
  },
  methods: {
    handlePlay() {
      this.playing = true
    },
    handlePause() {
      this.playing = false
    },
    handleClose() {
      if (!this.$refs.videoPlayer.paused) {
        this.$refs.videoPlayer.pause()
      }
      this.$emit('update:visible', false)
    },
    selectVideo(index) {
      this.active = index
      setTimeout(() => {
        this.$refs.videoPlayer.play()
      }, 100);
    },
    // viewMore(id) {
    //   this.handleClose()
    //   this.$emit('viewMore', id)
    // }
  }
}
</script>

<style lang="scss" scoped>
.mask-layer {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.page-helper-container {
  display: flex;
  width: 80%;
  max-height: 80%;
  background-color: #ffffffad;
  padding: 5px;
  // min-height: 500px;
  // min-width: 1000px;
  border-radius: 2px;
  position: relative;
  min-width:680px;
  min-height: 500px;
}
.close-button {
  position: absolute;
  right: -50px;
  top: -50px;
  font-size: 50px;
  cursor: pointer;
}
.video-list {
  flex: 1;
  border-radius: 5px;
  background-color: #f1f1f1bf;
  min-width: 200px;
  overflow: scroll;
  // overflow: auto;
  // /* 隐藏滚动条 */
  // scrollbar-width: none;
  // -ms-overflow-style: none;
  // /* Webkit 浏览器 */
  // &::-webkit-scrollbar {
  //     display: none;
  // }
  ul {
    list-style: none;
    padding: 0 20px;
    li {
      margin-top: 20px;
      .video-title {
        text-align: left;
        font-size: 15px;
        font-weight: 500;
        padding-bottom: 10px;
      }
      .video-box {
        position: relative;
        cursor: pointer;
        outline: 5px solid #375676;
        height: 100px;
        .video-cover {
          width: 100%;
          height: 100%;
        }
        .play-button-small {
          position: absolute;
          top: 10px;
          right: 10px;
          color: #fff;
          font-size: 18px;
        }
        .play-button-large {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #fff;
          font-size: 50px;
          z-index: 100;
          opacity: 0;
        }
        .video-play-duration {
          position: absolute;
          bottom: 10px;
          right: 10px;
          color: #fff;
          font-size: 12px;
        }
        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: #00000000;
          transition: background-color .2s linear;
        }
        &:hover {
          .play-button-small {
            opacity: 0;
          }
          .play-button-large {
            opacity: .8;
          }
          &::before {
            background-color: #00000051;
            z-index: 99;
          }
        }
      }
      .video-box-active {
        outline-color: #409EFF;
      }
    }
  }
}
.player-box {
  flex: 5;
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
}
.video-player {
  flex: 3;
  padding: 20px;
  display: flex;
  flex-direction: column;
  background-color: #f1f1f1;
  min-width: 400px;
  // justify-content: space-evenly;
  .video-player-title {
    font-size: 25px;
    font-weight: bold;
  }
  .video-player-remark {
    color: #7b7b7b;
    font-size: 12px;
    line-height: 15px;
    padding-top: 5px;
  }
}
.text-player {
  flex: 1.5;
  background-color: #f1f1f1bf;
  padding: 20px;
  box-sizing: border-box;
  min-width: 250px;
  min-height: 100%;
  max-height: 100%;
  overflow: scroll;
  position: relative;
}
.scrollbar-hidden {
  /* 隐藏滚动条 */
  scrollbar-width: none;
  -ms-overflow-style: none;
  /* Webkit 浏览器 */
  &::-webkit-scrollbar {
      display: none;
  }
}
</style>
